import colors from "../colors";

export default colors("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");



//////////////////
// WEBPACK FOOTER
// ../~/d3-scale-chromatic/src/categorical/Paired.js
// module id = E9sC
// module chunks = 0